var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
import { borderRightRadius, stateColor } from '@vital-ui/react-utils';
import constants from './constants';
var Root = styled('div').attrs(function (_a) {
    var width = _a.width;
    return ({
        style: { width: width },
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  border-radius: 5px;\n  left: 0;\n  height: ", ";\n  top: 0;\n  pointer-events: none;\n  background-color: ", ";\n  ", ";\n"], ["\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  border-radius: 5px;\n  left: 0;\n  height: ", ";\n  top: 0;\n  pointer-events: none;\n  background-color: ",
    ";\n  ", ";\n"])), function (props) { return constants[props.size].trackHeight; }, function (props) {
    return stateColor(props, props.disabled
        ? props.theme.disabledBackground
        : props.theme.background);
}, borderRightRadius(0));
Root.defaultProps = {
    theme: defaultTheme,
};
var Selection = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, width = _a.width, _d = _a.alarm, alarm = _d === void 0 ? false : _d, _e = _a.warning, warning = _e === void 0 ? false : _e, _f = _a.success, success = _f === void 0 ? false : _f;
    return (React.createElement(Root, { size: size, disabled: disabled, width: width, alarm: alarm, warning: warning, success: success }));
};
Selection.defaultProps = {
    size: 'medium',
    disabled: false,
    alarm: false,
    warning: false,
    success: false,
};
export default Selection;
var templateObject_1;
//# sourceMappingURL=Selection.js.map